webpackJsonp([7],{

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Company_vue__ = __webpack_require__(380);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3022f81c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Company_vue__ = __webpack_require__(481);
function injectStyle (ssrContext) {
  __webpack_require__(479)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3022f81c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Company_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3022f81c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Company_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(181), __esModule: true };

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_currency_formatter__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_currency_formatter__);







var UtilFormatter = function () {
  function UtilFormatter() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, UtilFormatter);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(UtilFormatter, null, [{
    key: "setFormatValue",
    value: function setFormatValue() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      return __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default.a.format(value, {
        code: "BRL",
        precision: 4
      });
    }
  }, {
    key: "setUnformatValue",
    value: function setUnformatValue() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      if (value) return parseFloat(__WEBPACK_IMPORTED_MODULE_3_currency_formatter___default.a.unformat(value, {
        code: "BRL"
      }));

      return "R$ 0,0000";
    }

    // padrão dd/mm/yyyy

  }, {
    key: "formatDateBR",
    value: function formatDateBR(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + "/" + month + "/" + year;
    }
    //de isoDate para data dd/mm/yyyy

  }, {
    key: "formatDateISOToBR",
    value: function formatDateISOToBR(date) {
      if (!date) return null;

      var _date$substring$split = date.substring(0, 10).split('-'),
          _date$substring$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$substring$split, 3),
          year = _date$substring$split2[0],
          month = _date$substring$split2[1],
          day = _date$substring$split2[2];

      return day + "/" + month + "/" + year;
    }
    // padrão yyyy-mm-dd

  }, {
    key: "formatDateUS",
    value: function formatDateUS(date) {
      if (!date) return null;

      var _date$split3 = date.split('-'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          year = _date$split4[0],
          month = _date$split4[1],
          day = _date$split4[2];

      return year + "-" + month + "-" + day;
    }
  }]);

  return UtilFormatter;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (UtilFormatter);

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(188), __esModule: true };

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(182);
module.exports = __webpack_require__(3).Object.assign;


/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(8);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(183) });


/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(5);
var getKeys = __webpack_require__(63);
var gOPS = __webpack_require__(184);
var pIE = __webpack_require__(185);
var toObject = __webpack_require__(65);
var IObject = __webpack_require__(64);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(34)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 184:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 185:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(62);
__webpack_require__(61);
module.exports = __webpack_require__(189);


/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var get = __webpack_require__(66);
module.exports = __webpack_require__(3).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configuration__ = __webpack_require__(59);








var url = __WEBPACK_IMPORTED_MODULE_5__configuration__["a" /* default */].apiHost;

var UserService = function () {
  function UserService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, UserService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(UserService, null, [{
    key: 'validade',
    value: function validade(person) {
      var errors = [];
      if (person.isLegalPerson) {
        if (!person.name) errors.push('nome');
        if (!person.email) errors.push('e-mail');
        if (!person.cpf) errors.push('cpf');
        if (!person.rg) errors.push('rg');
      }

      if (errors.length > 0) return errors;else return null;
    }
  }, {
    key: 'getAll',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var users;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + "persons");

              case 3:
                users = _context.sent;
                return _context.abrupt('return', users.data);

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);
                throw _context.t0.response.data;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getAll() {
        return _ref.apply(this, arguments);
      }

      return getAll;
    }() // getAll()

  }, {
    key: 'getPersonsForSpecificData',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var personsSaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + 'persons/find/ _id name socialName  address');

              case 3:
                personsSaved = _context2.sent;
                return _context2.abrupt('return', personsSaved.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0.response.data;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function getPersonsForSpecificData() {
        return _ref2.apply(this, arguments);
      }

      return getPersonsForSpecificData;
    }()
  }, {
    key: 'save',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(person) {
        var personSaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url + "persons", person);

              case 3:
                personSaved = _context3.sent;
                return _context3.abrupt('return', personSaved.data);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0.response.data;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function save(_x) {
        return _ref3.apply(this, arguments);
      }

      return save;
    }() // save()

  }, {
    key: 'update',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(person) {
        var personUpdated;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url + "persons", person);

              case 3:
                personUpdated = _context4.sent;
                return _context4.abrupt('return', personUpdated.data);

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);
                throw _context4.t0.response.data;

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));

      function update(_x2) {
        return _ref4.apply(this, arguments);
      }

      return update;
    }() // update()

  }, {
    key: 'remove',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(person) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(url + "persons", {
                  data: person
                });

              case 3:
                _context5.next = 8;
                break;

              case 5:
                _context5.prev = 5;
                _context5.t0 = _context5['catch'](0);
                throw _context5.t0.response.data;

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 5]]);
      }));

      function remove(_x3) {
        return _ref5.apply(this, arguments);
      }

      return remove;
    }() // remove()

  }, {
    key: 'searchCnpj',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(cnpj) {
        var validCnpj;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url + "searchCnpj", cnpj);

              case 3:
                validCnpj = _context6.sent;
                return _context6.abrupt('return', validCnpj.data);

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6['catch'](0);
                throw _context6.t0.response.data;

              case 10:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 7]]);
      }));

      function searchCnpj(_x4) {
        return _ref6.apply(this, arguments);
      }

      return searchCnpj;
    }() // searchCnpj()

  }]);

  return UserService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (UserService);

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(193);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(179);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(194), __esModule: true };

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(62);
__webpack_require__(61);
module.exports = __webpack_require__(195);


/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(35);
var ITERATOR = __webpack_require__(2)('iterator');
var Iterators = __webpack_require__(10);
module.exports = __webpack_require__(3).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

var accounting = __webpack_require__(197)
var assign = __webpack_require__(198)
var localeCurrency = __webpack_require__(199)
var currencies = __webpack_require__(201)
var localeFormats = __webpack_require__(202)

var defaultCurrency = {
  symbol: '',
  thousandsSeparator: ',',
  decimalSeparator: '.',
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
}

var defaultLocaleFormat = {}

var formatMapping = [
  {
    symbolOnLeft: true,
    spaceBetweenAmountAndSymbol: false,
    format: {
      pos: '%s%v',
      neg: '-%s%v',
      zero: '%s%v'
    }
  },
  {
    symbolOnLeft: true,
    spaceBetweenAmountAndSymbol: true,
    format: {
      pos: '%s %v',
      neg: '-%s %v',
      zero: '%s %v'
    }
  },
  {
    symbolOnLeft: false,
    spaceBetweenAmountAndSymbol: false,
    format: {
      pos: '%v%s',
      neg: '-%v%s',
      zero: '%v%s'
    }
  },
  {
    symbolOnLeft: false,
    spaceBetweenAmountAndSymbol: true,
    format: {
      pos: '%v %s',
      neg: '-%v %s',
      zero: '%v %s'
    }
  }
]

function format(value, options) {
  var code = options.code || (options.locale && localeCurrency.getCurrency(options.locale))
  var localeMatch = /^([a-z]+)([_-]([a-z]+))?$/i.exec(options.locale) || []
  var language = localeMatch[1]
  var region = localeMatch[3]
  var localeFormat = assign({}, defaultLocaleFormat,
                            localeFormats[language] || {},
                            localeFormats[language + '-' + region] || {})
  var currency = assign({}, defaultCurrency, findCurrency(code), localeFormat)
  
  var symbolOnLeft = currency.symbolOnLeft
  var spaceBetweenAmountAndSymbol = currency.spaceBetweenAmountAndSymbol

  var format = formatMapping.filter(function(f) {
    return f.symbolOnLeft == symbolOnLeft && f.spaceBetweenAmountAndSymbol == spaceBetweenAmountAndSymbol
  })[0].format

  return accounting.formatMoney(value, {
    symbol: isUndefined(options.symbol)
              ? currency.symbol
              : options.symbol,

    decimal: isUndefined(options.decimal)
              ? currency.decimalSeparator
              : options.decimal,

    thousand: isUndefined(options.thousand)
              ? currency.thousandsSeparator
              : options.thousand,

    precision: typeof options.precision === 'number'
              ? options.precision
              : currency.decimalDigits,

    format: ['string', 'object'].indexOf(typeof options.format) > -1
              ? options.format
              : format
  })
}

function findCurrency (currencyCode) {
  return currencies[currencyCode]
}

function isUndefined (val) {
  return typeof val === 'undefined'
}

function unformat(value, options) {
  var code = options.code || (options.locale && localeCurrency.getCurrency(options.locale))
  var localeFormat = localeFormats[options.locale] || defaultLocaleFormat
  var currency = assign({}, defaultCurrency, findCurrency(code), localeFormat)
  var decimal = isUndefined(options.decimal) ? currency.decimalSeparator : options.decimal
  return accounting.unformat(value, decimal)
}

module.exports = {
  defaultCurrency: defaultCurrency,
  get currencies() {
    // In favor of backwards compatibility, the currencies map is converted to an array here
    return Object.keys(currencies).map(function(key) {
      return currencies[key]
    })
  },
  findCurrency: findCurrency,
  format: format,
  unformat: unformat
}

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

/*!
 * accounting.js v0.4.1
 * Copyright 2014 Open Exchange Rates
 *
 * Freely distributable under the MIT license.
 * Portions of accounting.js are inspired or borrowed from underscore.js
 *
 * Full details and documentation:
 * http://openexchangerates.github.io/accounting.js/
 */

(function(root, undefined) {

	/* --- Setup --- */

	// Create the local library object, to be exported or referenced globally later
	var lib = {};

	// Current version
	lib.version = '0.4.1';


	/* --- Exposed settings --- */

	// The library's settings configuration object. Contains default parameters for
	// currency and number formatting
	lib.settings = {
		currency: {
			symbol : "$",		// default currency symbol is '$'
			format : "%s%v",	// controls output: %s = symbol, %v = value (can be object, see docs)
			decimal : ".",		// decimal point separator
			thousand : ",",		// thousands separator
			precision : 2,		// decimal places
			grouping : 3		// digit grouping (not implemented yet)
		},
		number: {
			precision : 0,		// default precision on numbers is 0
			grouping : 3,		// digit grouping (not implemented yet)
			thousand : ",",
			decimal : "."
		}
	};


	/* --- Internal Helper Methods --- */

	// Store reference to possibly-available ECMAScript 5 methods for later
	var nativeMap = Array.prototype.map,
		nativeIsArray = Array.isArray,
		toString = Object.prototype.toString;

	/**
	 * Tests whether supplied parameter is a string
	 * from underscore.js
	 */
	function isString(obj) {
		return !!(obj === '' || (obj && obj.charCodeAt && obj.substr));
	}

	/**
	 * Tests whether supplied parameter is a string
	 * from underscore.js, delegates to ECMA5's native Array.isArray
	 */
	function isArray(obj) {
		return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
	}

	/**
	 * Tests whether supplied parameter is a true object
	 */
	function isObject(obj) {
		return obj && toString.call(obj) === '[object Object]';
	}

	/**
	 * Extends an object with a defaults object, similar to underscore's _.defaults
	 *
	 * Used for abstracting parameter handling from API methods
	 */
	function defaults(object, defs) {
		var key;
		object = object || {};
		defs = defs || {};
		// Iterate over object non-prototype properties:
		for (key in defs) {
			if (defs.hasOwnProperty(key)) {
				// Replace values with defaults only if undefined (allow empty/zero values):
				if (object[key] == null) object[key] = defs[key];
			}
		}
		return object;
	}

	/**
	 * Implementation of `Array.map()` for iteration loops
	 *
	 * Returns a new Array as a result of calling `iterator` on each array value.
	 * Defers to native Array.map if available
	 */
	function map(obj, iterator, context) {
		var results = [], i, j;

		if (!obj) return results;

		// Use native .map method if it exists:
		if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);

		// Fallback for native .map:
		for (i = 0, j = obj.length; i < j; i++ ) {
			results[i] = iterator.call(context, obj[i], i, obj);
		}
		return results;
	}

	/**
	 * Check and normalise the value of precision (must be positive integer)
	 */
	function checkPrecision(val, base) {
		val = Math.round(Math.abs(val));
		return isNaN(val)? base : val;
	}


	/**
	 * Parses a format string or object and returns format obj for use in rendering
	 *
	 * `format` is either a string with the default (positive) format, or object
	 * containing `pos` (required), `neg` and `zero` values (or a function returning
	 * either a string or object)
	 *
	 * Either string or format.pos must contain "%v" (value) to be valid
	 */
	function checkCurrencyFormat(format) {
		var defaults = lib.settings.currency.format;

		// Allow function as format parameter (should return string or object):
		if ( typeof format === "function" ) format = format();

		// Format can be a string, in which case `value` ("%v") must be present:
		if ( isString( format ) && format.match("%v") ) {

			// Create and return positive, negative and zero formats:
			return {
				pos : format,
				neg : format.replace("-", "").replace("%v", "-%v"),
				zero : format
			};

		// If no format, or object is missing valid positive value, use defaults:
		} else if ( !format || !format.pos || !format.pos.match("%v") ) {

			// If defaults is a string, casts it to an object for faster checking next time:
			return ( !isString( defaults ) ) ? defaults : lib.settings.currency.format = {
				pos : defaults,
				neg : defaults.replace("%v", "-%v"),
				zero : defaults
			};

		}
		// Otherwise, assume format was fine:
		return format;
	}


	/* --- API Methods --- */

	/**
	 * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
	 * Alias: `accounting.parse(string)`
	 *
	 * Decimal must be included in the regular expression to match floats (defaults to
	 * accounting.settings.number.decimal), so if the number uses a non-standard decimal 
	 * separator, provide it as the second argument.
	 *
	 * Also matches bracketed negatives (eg. "$ (1.99)" => -1.99)
	 *
	 * Doesn't throw any errors (`NaN`s become 0) but this may change in future
	 */
	var unformat = lib.unformat = lib.parse = function(value, decimal) {
		// Recursively unformat arrays:
		if (isArray(value)) {
			return map(value, function(val) {
				return unformat(val, decimal);
			});
		}

		// Fails silently (need decent errors):
		value = value || 0;

		// Return the value as-is if it's already a number:
		if (typeof value === "number") return value;

		// Default decimal point comes from settings, but could be set to eg. "," in opts:
		decimal = decimal || lib.settings.number.decimal;

		 // Build regex to strip out everything except digits, decimal point and minus sign:
		var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
			unformatted = parseFloat(
				("" + value)
				.replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
				.replace(regex, '')         // strip out any cruft
				.replace(decimal, '.')      // make sure decimal point is standard
			);

		// This will fail silently which may cause trouble, let's wait and see:
		return !isNaN(unformatted) ? unformatted : 0;
	};


	/**
	 * Implementation of toFixed() that treats floats more like decimals
	 *
	 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === "0.61") that present
	 * problems for accounting- and finance-related software.
	 */
	var toFixed = lib.toFixed = function(value, precision) {
		precision = checkPrecision(precision, lib.settings.number.precision);
		var power = Math.pow(10, precision);

		// Multiply up by precision, round accurately, then divide and use native toFixed():
		return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
	};


	/**
	 * Format a number, with comma-separated thousands and custom precision/decimal places
	 * Alias: `accounting.format()`
	 *
	 * Localise by overriding the precision and thousand / decimal separators
	 * 2nd parameter `precision` can be an object matching `settings.number`
	 */
	var formatNumber = lib.formatNumber = lib.format = function(number, precision, thousand, decimal) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function(val) {
				return formatNumber(val, precision, thousand, decimal);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(precision) ? precision : {
					precision : precision,
					thousand : thousand,
					decimal : decimal
				}),
				lib.settings.number
			),

			// Clean up precision
			usePrecision = checkPrecision(opts.precision),

			// Do some calc:
			negative = number < 0 ? "-" : "",
			base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
			mod = base.length > 3 ? base.length % 3 : 0;

		// Format the number:
		return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
	};


	/**
	 * Format a number into currency
	 *
	 * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
	 * defaults: (0, "$", 2, ",", ".", "%s%v")
	 *
	 * Localise by overriding the symbol, precision, thousand / decimal separators and format
	 * Second param can be an object matching `settings.currency` which is the easiest way.
	 *
	 * To do: tidy up the parameters
	 */
	var formatMoney = lib.formatMoney = function(number, symbol, precision, thousand, decimal, format) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function(val){
				return formatMoney(val, symbol, precision, thousand, decimal, format);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(symbol) ? symbol : {
					symbol : symbol,
					precision : precision,
					thousand : thousand,
					decimal : decimal,
					format : format
				}),
				lib.settings.currency
			),

			// Check format (returns object with pos, neg and zero):
			formats = checkCurrencyFormat(opts.format),

			// Choose which format to use for this value:
			useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;

		// Return with currency symbol added:
		return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
	};


	/**
	 * Format a list of numbers into an accounting column, padding with whitespace
	 * to line up currency symbols, thousand separators and decimals places
	 *
	 * List should be an array of numbers
	 * Second parameter can be an object containing keys that match the params
	 *
	 * Returns array of accouting-formatted number strings of same length
	 *
	 * NB: `white-space:pre` CSS rule is required on the list container to prevent
	 * browsers from collapsing the whitespace in the output strings.
	 */
	lib.formatColumn = function(list, symbol, precision, thousand, decimal, format) {
		if (!list) return [];

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(symbol) ? symbol : {
					symbol : symbol,
					precision : precision,
					thousand : thousand,
					decimal : decimal,
					format : format
				}),
				lib.settings.currency
			),

			// Check format (returns object with pos, neg and zero), only need pos for now:
			formats = checkCurrencyFormat(opts.format),

			// Whether to pad at start of string or after currency symbol:
			padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,

			// Store value for the length of the longest string in the column:
			maxLength = 0,

			// Format the list according to options, store the length of the longest string:
			formatted = map(list, function(val, i) {
				if (isArray(val)) {
					// Recursively format columns if list is a multi-dimensional array:
					return lib.formatColumn(val, opts);
				} else {
					// Clean up the value
					val = unformat(val);

					// Choose which format to use for this value (pos, neg or zero):
					var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,

						// Format this value, push into formatted list and save the length:
						fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));

					if (fVal.length > maxLength) maxLength = fVal.length;
					return fVal;
				}
			});

		// Pad each number in the list and send back the column of numbers:
		return map(formatted, function(val, i) {
			// Only if this is a string (not a nested array, which would have already been padded):
			if (isString(val) && val.length < maxLength) {
				// Depending on symbol position, pad after symbol or at index 0:
				return padAfterSymbol ? val.replace(opts.symbol, opts.symbol+(new Array(maxLength - val.length + 1).join(" "))) : (new Array(maxLength - val.length + 1).join(" ")) + val;
			}
			return val;
		});
	};


	/* --- Module Definition --- */

	// Export accounting for CommonJS. If being loaded as an AMD module, define it as such.
	// Otherwise, just add `accounting` to the global object
	if (true) {
		if (typeof module !== 'undefined' && module.exports) {
			exports = module.exports = lib;
		}
		exports.accounting = lib;
	} else if (typeof define === 'function' && define.amd) {
		// Return the library as an AMD module:
		define([], function() {
			return lib;
		});
	} else {
		// Use accounting.noConflict to restore `accounting` back to its original value.
		// Returns a reference to the library's `accounting` object;
		// e.g. `var numbers = accounting.noConflict();`
		lib.noConflict = (function(oldAccounting) {
			return function() {
				// Reset the value of the root's `accounting` variable:
				root.accounting = oldAccounting;
				// Delete the noConflict method:
				lib.noConflict = undefined;
				// Return reference to the library to re-assign it:
				return lib;
			};
		})(root.accounting);

		// Declare `fx` on the root (global/window) object:
		root['accounting'] = lib;
	}

	// Root will be `window` in browser or `global` on the server:
}(this));


/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

var map = __webpack_require__(200);

var getCountryCode = function(localeString) {
    var components = localeString.split("_");
    if (components.length == 2) {
        return components.pop();
    }
    components = localeString.split("-");
    if (components.length == 2) {
        return components.pop();
    }
    return localeString;
}

exports.getCurrency = function(locale) {
    var countryCode = getCountryCode(locale).toUpperCase();
    if (countryCode in map) {
        return map[countryCode];
    }
    return null;
}

exports.getLocales = function(currencyCode) {
    currencyCode = currencyCode.toUpperCase();
    var locales = [];
    for (countryCode in map) {
        if (map[countryCode] === currencyCode) {
            locales.push(countryCode);
        }
    }
    return locales;
}

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

// Generated using ShowCurrencies.java
var map = {
AD: 'EUR',
AE: 'AED',
AF: 'AFN',
AG: 'XCD',
AI: 'XCD',
AL: 'ALL',
AM: 'AMD',
AN: 'ANG',
AO: 'AOA',
AR: 'ARS',
AS: 'USD',
AT: 'EUR',
AU: 'AUD',
AW: 'AWG',
AX: 'EUR',
AZ: 'AZN',
BA: 'BAM',
BB: 'BBD',
BD: 'BDT',
BE: 'EUR',
BF: 'XOF',
BG: 'BGN',
BH: 'BHD',
BI: 'BIF',
BJ: 'XOF',
BL: 'EUR',
BM: 'BMD',
BN: 'BND',
BO: 'BOB',
BQ: 'USD',
BR: 'BRL',
BS: 'BSD',
BT: 'BTN',
BV: 'NOK',
BW: 'BWP',
BY: 'BYR',
BZ: 'BZD',
CA: 'CAD',
CC: 'AUD',
CD: 'CDF',
CF: 'XAF',
CG: 'XAF',
CH: 'CHF',
CI: 'XOF',
CK: 'NZD',
CL: 'CLP',
CM: 'XAF',
CN: 'CNY',
CO: 'COP',
CR: 'CRC',
CU: 'CUP',
CV: 'CVE',
CW: 'ANG',
CX: 'AUD',
CY: 'EUR',
CZ: 'CZK',
DE: 'EUR',
DJ: 'DJF',
DK: 'DKK',
DM: 'XCD',
DO: 'DOP',
DZ: 'DZD',
EC: 'USD',
EE: 'EUR',
EG: 'EGP',
EH: 'MAD',
ER: 'ERN',
ES: 'EUR',
ET: 'ETB',
FI: 'EUR',
FJ: 'FJD',
FK: 'FKP',
FM: 'USD',
FO: 'DKK',
FR: 'EUR',
GA: 'XAF',
GB: 'GBP',
GD: 'XCD',
GE: 'GEL',
GF: 'EUR',
GG: 'GBP',
GH: 'GHS',
GI: 'GIP',
GL: 'DKK',
GM: 'GMD',
GN: 'GNF',
GP: 'EUR',
GQ: 'XAF',
GR: 'EUR',
GS: 'GBP',
GT: 'GTQ',
GU: 'USD',
GW: 'XOF',
GY: 'GYD',
HK: 'HKD',
HM: 'AUD',
HN: 'HNL',
HR: 'HRK',
HT: 'HTG',
HU: 'HUF',
ID: 'IDR',
IE: 'EUR',
IL: 'ILS',
IM: 'GBP',
IN: 'INR',
IO: 'USD',
IQ: 'IQD',
IR: 'IRR',
IS: 'ISK',
IT: 'EUR',
JE: 'GBP',
JM: 'JMD',
JO: 'JOD',
JP: 'JPY',
KE: 'KES',
KG: 'KGS',
KH: 'KHR',
KI: 'AUD',
KM: 'KMF',
KN: 'XCD',
KP: 'KPW',
KR: 'KRW',
KW: 'KWD',
KY: 'KYD',
KZ: 'KZT',
LA: 'LAK',
LB: 'LBP',
LC: 'XCD',
LI: 'CHF',
LK: 'LKR',
LR: 'LRD',
LS: 'LSL',
LT: 'LTL',
LU: 'EUR',
LV: 'LVL',
LY: 'LYD',
MA: 'MAD',
MC: 'EUR',
MD: 'MDL',
ME: 'EUR',
MF: 'EUR',
MG: 'MGA',
MH: 'USD',
MK: 'MKD',
ML: 'XOF',
MM: 'MMK',
MN: 'MNT',
MO: 'MOP',
MP: 'USD',
MQ: 'EUR',
MR: 'MRO',
MS: 'XCD',
MT: 'EUR',
MU: 'MUR',
MV: 'MVR',
MW: 'MWK',
MX: 'MXN',
MY: 'MYR',
MZ: 'MZN',
NA: 'NAD',
NC: 'XPF',
NE: 'XOF',
NF: 'AUD',
NG: 'NGN',
NI: 'NIO',
NL: 'EUR',
NO: 'NOK',
NP: 'NPR',
NR: 'AUD',
NU: 'NZD',
NZ: 'NZD',
OM: 'OMR',
PA: 'PAB',
PE: 'PEN',
PF: 'XPF',
PG: 'PGK',
PH: 'PHP',
PK: 'PKR',
PL: 'PLN',
PM: 'EUR',
PN: 'NZD',
PR: 'USD',
PS: 'ILS',
PT: 'EUR',
PW: 'USD',
PY: 'PYG',
QA: 'QAR',
RE: 'EUR',
RO: 'RON',
RS: 'RSD',
RU: 'RUB',
RW: 'RWF',
SA: 'SAR',
SB: 'SBD',
SC: 'SCR',
SD: 'SDG',
SE: 'SEK',
SG: 'SGD',
SH: 'SHP',
SI: 'EUR',
SJ: 'NOK',
SK: 'EUR',
SL: 'SLL',
SM: 'EUR',
SN: 'XOF',
SO: 'SOS',
SR: 'SRD',
ST: 'STD',
SV: 'SVC',
SX: 'ANG',
SY: 'SYP',
SZ: 'SZL',
TC: 'USD',
TD: 'XAF',
TF: 'EUR',
TG: 'XOF',
TH: 'THB',
TJ: 'TJS',
TK: 'NZD',
TL: 'USD',
TM: 'TMT',
TN: 'TND',
TO: 'TOP',
TR: 'TRY',
TT: 'TTD',
TV: 'AUD',
TW: 'TWD',
TZ: 'TZS',
UA: 'UAH',
UG: 'UGX',
UM: 'USD',
US: 'USD',
UY: 'UYU',
UZ: 'UZS',
VA: 'EUR',
VC: 'XCD',
VE: 'VEF',
VG: 'USD',
VI: 'USD',
VN: 'VND',
VU: 'VUV',
WF: 'XPF',
WS: 'WST',
YE: 'YER',
YT: 'EUR',
ZA: 'ZAR',
ZM: 'ZMK',
ZW: 'ZWL'
};

module.exports = map;

/***/ }),

/***/ 201:
/***/ (function(module, exports) {

module.exports = {"AED":{"code":"AED","symbol":"د.إ.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"AFN":{"code":"AFN","symbol":"؋","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"ALL":{"code":"ALL","symbol":"Lek","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"AMD":{"code":"AMD","symbol":"֏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"ANG":{"code":"ANG","symbol":"ƒ","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"AOA":{"code":"AOA","symbol":"Kz","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"ARS":{"code":"ARS","symbol":"$","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"AUD":{"code":"AUD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"AWG":{"code":"AWG","symbol":"ƒ","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"AZN":{"code":"AZN","symbol":"₼","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BAM":{"code":"BAM","symbol":"КМ","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BBD":{"code":"BBD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"BDT":{"code":"BDT","symbol":"৳","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":0},"BGN":{"code":"BGN","symbol":"лв.","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BHD":{"code":"BHD","symbol":"د.ب.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":3},"BIF":{"code":"BIF","symbol":"FBu","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"BMD":{"code":"BMD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"BND":{"code":"BND","symbol":"$","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"BOB":{"code":"BOB","symbol":"Bs","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BRL":{"code":"BRL","symbol":"R$","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BSD":{"code":"BSD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"BTC":{"code":"BTC","symbol":"Ƀ","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":8},"BTN":{"code":"BTN","symbol":"Nu.","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":1},"BWP":{"code":"BWP","symbol":"P","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"BYR":{"code":"BYR","symbol":"р.","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BYN":{"code":"BYN","symbol":"р.","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BZD":{"code":"BZD","symbol":"BZ$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CAD":{"code":"CAD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CDF":{"code":"CDF","symbol":"FC","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CHF":{"code":"CHF","symbol":"CHF","thousandsSeparator":"'","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"CLP":{"code":"CLP","symbol":"$","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":0},"CNY":{"code":"CNY","symbol":"¥","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"COP":{"code":"COP","symbol":"$","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"CRC":{"code":"CRC","symbol":"₡","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CUC":{"code":"CUC","symbol":"CUC","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CUP":{"code":"CUP","symbol":"$MN","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CVE":{"code":"CVE","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CZK":{"code":"CZK","symbol":"Kč","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"DJF":{"code":"DJF","symbol":"Fdj","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"DKK":{"code":"DKK","symbol":"kr.","thousandsSeparator":"","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"DOP":{"code":"DOP","symbol":"RD$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"DZD":{"code":"DZD","symbol":"د.ج.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"EGP":{"code":"EGP","symbol":"ج.م.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"ERN":{"code":"ERN","symbol":"Nfk","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"ETB":{"code":"ETB","symbol":"ETB","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"EUR":{"code":"EUR","symbol":"€","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"FJD":{"code":"FJD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"FKP":{"code":"FKP","symbol":"£","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GBP":{"code":"GBP","symbol":"£","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GEL":{"code":"GEL","symbol":"GEL","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"GHS":{"code":"GHS","symbol":"₵","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GIP":{"code":"GIP","symbol":"£","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GMD":{"code":"GMD","symbol":"D","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GNF":{"code":"GNF","symbol":"FG","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"GTQ":{"code":"GTQ","symbol":"Q","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GYD":{"code":"GYD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"HKD":{"code":"HKD","symbol":"HK$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"HNL":{"code":"HNL","symbol":"L.","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"HRK":{"code":"HRK","symbol":"kn","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"HTG":{"code":"HTG","symbol":"G","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"HUF":{"code":"HUF","symbol":"Ft","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"IDR":{"code":"IDR","symbol":"Rp","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"ILS":{"code":"ILS","symbol":"₪","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"INR":{"code":"INR","symbol":"₹","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"IQD":{"code":"IQD","symbol":"د.ع.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"IRR":{"code":"IRR","symbol":"﷼","thousandsSeparator":",","decimalSeparator":"/","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"ISK":{"code":"ISK","symbol":"kr.","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":0},"JMD":{"code":"JMD","symbol":"J$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"JOD":{"code":"JOD","symbol":"د.ا.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":3},"JPY":{"code":"JPY","symbol":"¥","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"KES":{"code":"KES","symbol":"KSh","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"KGS":{"code":"KGS","symbol":"сом","thousandsSeparator":" ","decimalSeparator":"-","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"KHR":{"code":"KHR","symbol":"៛","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"KMF":{"code":"KMF","symbol":"CF","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"KPW":{"code":"KPW","symbol":"₩","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"KRW":{"code":"KRW","symbol":"₩","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"KWD":{"code":"KWD","symbol":"د.ك.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":3},"KYD":{"code":"KYD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"KZT":{"code":"KZT","symbol":"₸","thousandsSeparator":" ","decimalSeparator":"-","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"LAK":{"code":"LAK","symbol":"₭","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"LBP":{"code":"LBP","symbol":"ل.ل.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"LKR":{"code":"LKR","symbol":"₨","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":0},"LRD":{"code":"LRD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"LSL":{"code":"LSL","symbol":"M","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"LYD":{"code":"LYD","symbol":"د.ل.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":3},"MAD":{"code":"MAD","symbol":"د.م.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"MDL":{"code":"MDL","symbol":"lei","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"MGA":{"code":"MGA","symbol":"Ar","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"MKD":{"code":"MKD","symbol":"ден.","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"MMK":{"code":"MMK","symbol":"K","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MNT":{"code":"MNT","symbol":"₮","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MOP":{"code":"MOP","symbol":"MOP$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MRO":{"code":"MRO","symbol":"UM","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MTL":{"code":"MTL","symbol":"₤","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MUR":{"code":"MUR","symbol":"₨","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MVR":{"code":"MVR","symbol":"MVR","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":1},"MWK":{"code":"MWK","symbol":"MK","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MXN":{"code":"MXN","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MYR":{"code":"MYR","symbol":"RM","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MZN":{"code":"MZN","symbol":"MT","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"NAD":{"code":"NAD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"NGN":{"code":"NGN","symbol":"₦","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"NIO":{"code":"NIO","symbol":"C$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"NOK":{"code":"NOK","symbol":"kr","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"NPR":{"code":"NPR","symbol":"₨","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"NZD":{"code":"NZD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"OMR":{"code":"OMR","symbol":"﷼","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":3},"PAB":{"code":"PAB","symbol":"B/.","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"PEN":{"code":"PEN","symbol":"S/.","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"PGK":{"code":"PGK","symbol":"K","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"PHP":{"code":"PHP","symbol":"₱","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"PKR":{"code":"PKR","symbol":"₨","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"PLN":{"code":"PLN","symbol":"zł","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"PYG":{"code":"PYG","symbol":"₲","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"QAR":{"code":"QAR","symbol":"﷼","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"RON":{"code":"RON","symbol":"L","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"RSD":{"code":"RSD","symbol":"Дин.","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"RUB":{"code":"RUB","symbol":"₽","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"RWF":{"code":"RWF","symbol":"RWF","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"SAR":{"code":"SAR","symbol":"﷼","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"SBD":{"code":"SBD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SCR":{"code":"SCR","symbol":"₨","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SDD":{"code":"SDD","symbol":"LSd","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SDG":{"code":"SDG","symbol":"£‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SEK":{"code":"SEK","symbol":"kr","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"SGD":{"code":"SGD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SHP":{"code":"SHP","symbol":"£","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SLL":{"code":"SLL","symbol":"Le","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SOS":{"code":"SOS","symbol":"S","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SRD":{"code":"SRD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"STD":{"code":"STD","symbol":"Db","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SVC":{"code":"SVC","symbol":"₡","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SYP":{"code":"SYP","symbol":"£","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"SZL":{"code":"SZL","symbol":"E","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"THB":{"code":"THB","symbol":"฿","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TJS":{"code":"TJS","symbol":"TJS","thousandsSeparator":" ","decimalSeparator":";","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"TMT":{"code":"TMT","symbol":"m","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"TND":{"code":"TND","symbol":"د.ت.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":3},"TOP":{"code":"TOP","symbol":"T$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TRY":{"code":"TRY","symbol":"₺","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TTD":{"code":"TTD","symbol":"TT$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TVD":{"code":"TVD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TWD":{"code":"TWD","symbol":"NT$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TZS":{"code":"TZS","symbol":"TSh","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"UAH":{"code":"UAH","symbol":"₴","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"UGX":{"code":"UGX","symbol":"USh","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"USD":{"code":"USD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"UYU":{"code":"UYU","symbol":"$U","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"UZS":{"code":"UZS","symbol":"сўм","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"VEB":{"code":"VEB","symbol":"Bs.","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"VEF":{"code":"VEF","symbol":"Bs. F.","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"VND":{"code":"VND","symbol":"₫","thousandsSeparator":".","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":0},"VUV":{"code":"VUV","symbol":"VT","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"WST":{"code":"WST","symbol":"WS$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"XAF":{"code":"XAF","symbol":"F","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"XCD":{"code":"XCD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"XBT":{"code":"XBT","symbol":"Ƀ","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"XOF":{"code":"XOF","symbol":"F","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"XPF":{"code":"XPF","symbol":"F","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"YER":{"code":"YER","symbol":"﷼","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"ZAR":{"code":"ZAR","symbol":"R","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"ZMW":{"code":"ZMW","symbol":"ZK","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"WON":{"code":"WON","symbol":"₩","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2}}

/***/ }),

/***/ 202:
/***/ (function(module, exports) {

module.exports = {"de":{"thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"el":{"symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"thousandsSeparator":".","decimalSeparator":",","decimalDigits":2},"en-US":{"thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"en-IE":{"symbolOnLeft":true,"thousandsSeparator":",","decimalSeparator":".","spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"zh-CN":{"thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"es":{"thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"it":{"symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"thousandsSeparator":".","decimalSeparator":",","decimalDigits":2},"nl":{"symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"thousandsSeparator":".","decimalSeparator":",","decimalDigits":2}}

/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_UtilFormatter__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configuration__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PersonService__ = __webpack_require__(190);











var url = __WEBPACK_IMPORTED_MODULE_6__configuration__["a" /* default */].apiHost + "companies";

var CompanyService = function () {
  function CompanyService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CompanyService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CompanyService, null, [{
    key: 'getAll',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var companies;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('' + url);

              case 3:
                companies = _context.sent;
                return _context.abrupt('return', companies.data);

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);
                throw _context.t0.response.data;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getAll() {
        return _ref.apply(this, arguments);
      }

      return getAll;
    }() // getAll()

  }, {
    key: 'getCompaniesForSpecificData',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var companySaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + '/find/ _id socialName fantasyName address');

              case 3:
                companySaved = _context2.sent;
                return _context2.abrupt('return', companySaved.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0.response.data;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function getCompaniesForSpecificData() {
        return _ref2.apply(this, arguments);
      }

      return getCompaniesForSpecificData;
    }() //getCompaniesForSpecificData(data)

  }, {
    key: 'findWithoutDocuments',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var companySaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + '/noDocument');

              case 3:
                companySaved = _context3.sent;
                return _context3.abrupt('return', companySaved.data);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0.response.data;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function findWithoutDocuments() {
        return _ref3.apply(this, arguments);
      }

      return findWithoutDocuments;
    }() //getCompaniesForSpecificData(data)


  }, {
    key: 'save',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(company) {
        var companySaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('' + url, company);

              case 3:
                companySaved = _context4.sent;
                return _context4.abrupt('return', companySaved.data);

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);
                throw _context4.t0.response.data;

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));

      function save(_x) {
        return _ref4.apply(this, arguments);
      }

      return save;
    }() // save()

  }, {
    key: 'update',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(company) {
        var companyUpdated;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put('' + url, company);

              case 3:
                companyUpdated = _context5.sent;
                return _context5.abrupt('return', companyUpdated.data);

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5['catch'](0);
                throw _context5.t0.response.data;

              case 10:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 7]]);
      }));

      function update(_x2) {
        return _ref5.apply(this, arguments);
      }

      return update;
    }() // update()

  }, {
    key: 'remove',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(company) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete('' + url, {
                  data: company
                });

              case 3:
                _context6.next = 8;
                break;

              case 5:
                _context6.prev = 5;
                _context6.t0 = _context6['catch'](0);
                throw _context6.t0.response.data;

              case 8:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 5]]);
      }));

      function remove(_x3) {
        return _ref6.apply(this, arguments);
      }

      return remove;
    }() // remove()

  }]);

  return CompanyService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (CompanyService);

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);





var PersonConverter = function () {
  function PersonConverter() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PersonConverter);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PersonConverter, null, [{
    key: "getPersonConverterFrom",
    value: function getPersonConverterFrom(person) {
      if (person === {} || person === null || person === undefined) {
        return null;
      }

      return {
        socialName: person.nome,
        cnpj: person.cnpj,
        address: {
          addressType: person.logradouro,
          number: person.numero,
          cep: person.cep,
          district: person.bairro,
          complement: person.complemento,
          city: person.municipio,
          state: person.uf
        },

        phone: person.telefone,
        email: person.email,

        activityMain: person.atividade_principal,
        dateSituation: this.toPatternISO8601(person.data_situacao),

        secondaryEconomicActivity: person.atividades_secundarias,
        qsa: person.qsa,
        situation: person.situacao,
        openingDate: this.toPatternISO8601(person.abertura),
        legalNature: person.natureza_juridica,
        fantasyName: person.fantasia,
        lastUpdate: person.ultima_atualizacao,
        status: person.status,
        type: person.tipo,
        efr: person.efr,
        situationReason: person.motivo_situacao,
        specialSituation: person.situacao_especial,
        dateSpecialSituation: person.data_situacao_especial,
        shareCapital: person.capital_social,
        extra: person.extra,
        billing: person.billing,
        isLegalPerson: person.isLegalPerson,
        bankData: {},
        legalRepresentative: {},
        taxation: {}
      };
    } // getPersonConverterFrom()

  }, {
    key: "toPatternISO8601",
    value: function toPatternISO8601(dateBr) {
      // de: dd/MM/yyyy para: yyyy-MM-dd
      var split = dateBr.split("/");
      return new Date(Date.parse(split[2] + "/" + split[1] + "/" + split[0]));
    }
  }, {
    key: "toPatternBR",
    value: function toPatternBR(date) {
      // de: yyyy-MM-dd para: dd/MM/yyyy
      var day = "";
      var month = "";
      var year = "";

      if (!(date instanceof Date)) date = new Date();

      day = date.getDate();
      if (("" + day).length <= 1) day = "0" + day;

      month = date.getMonth() + 1;
      if (("" + month).length <= 1) month = "0" + month;

      year = date.getFullYear();

      return day + "/" + month + "/" + year;
    }
  }]);

  return PersonConverter;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (PersonConverter);

/***/ }),

/***/ 380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_CompanyService__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_PersonService__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_LegalPersonConverter__ = __webpack_require__(298);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      typesOfTributaion: ["Simples Nacional", "Lucro Presumido", "Lucro Real"],
      bankData: {},

      /*********\
      *****Visual*****
        \*********/
      //Alertas e dialogos
      alert: false,
      msgAlert: "",
      alertColor: "yellow darken-2",
      dialog: false,
      pdfWindow: false,
      desactivationDialog: false,
      tabsInfo: 0,
      /**********\
      ***Rules***
      \**********/
      inputRules: [function (v) {
        return !!v || 'Campo obrigatório';
      }],
      emailRules: [function (v) {
        return !!v || 'E-mail é obrigatório';
      }, function (v) {
        return (/.+@.+/.test(v) || 'Insira um e-mail válido'
        );
      }],
      taxationRules: [function (v) {
        return !!v || 'Selecione um tipo de tributação';
      }],
      /*********\
        ***Textos**
        \*********/
      deactivationText: "Ao desativar, essa informação não poderá ser utilizada em outras áreas do sistema!",
      footerText: "Total de empresas: ",
      emptyRecordsText: "Nenhuma empresa encontrada",
      emptySearchText: "Nenhuma empresa encontrada para",
      loadingRecordsText: "Carregando empresas...",
      pdfWindowTitle: "Editar Arquivo",
      desactivationDialogTitle: "Desativar Empresa",
      companyInfoTitle: "Detalhes Sobre a Empresa",
      title: "Listagem de Empresas",
      buttonTitle: "Novo",
      /*********\
      ***Informação***
        \*********/
      records: 0,
      loading: false,
      //Botões
      disabledButtonSave: true,
      /*******************\
      ***Data Table||Recursos***
        \*******************/
      //Data Tables
      search: "",
      headers: [{
        text: "Razão social",
        align: "center",
        value: "socialName"
      }, {
        text: "Nome fantasia",
        align: "center",
        value: "fantasyName"
      }, {
        text: "CNPJ",
        align: "center",
        value: "cnpj"
      }, {
        text: "E-Mail",
        align: "center",
        value: "email"
      }, {
        text: "Telefone",
        align: "center",
        value: "phone"
      }, {
        text: "Status",
        sortable: true,
        value: "socialName"
      }, {
        text: "",
        sortable: false,
        value: "socialName"
      }],
      //Recursos

      defaultCompany: {
        address: {},
        bankData: {},
        companyDocuments: [],
        contact: {},
        legalRepresentative: {},
        taxation: {}
      },
      company: {
        address: {},
        bankData: {},
        companyDocuments: [],
        contact: {},
        legalRepresentative: {},
        taxation: {}
      },
      companies: [],
      /******\
      ***Edição***
        \******/
      isEditing: false,
      isValidCnpj: false,
      validCnpj: {},
      cnpj: {},
      pdfModel: {},
      editingPdf: false,
      savingCompany: false,
      /********\
      ***Arquivos***
        \********/
      //Imagens
      imageName: "",
      imageUrl: "",
      //PDFs
      pdfName: "",
      pdfUrl: ""
    };
  },

  computed: {
    formTitle: function formTitle() {
      return this.company._id ? "Editar Empresa" : "Nova Empresa";
    },
    footerDynamicText: function footerDynamicText() {
      var text = this.loading ? this.loadingRecordsText : this.emptyRecordsText;
      return text;
    }
  },
  created: function created() {
    this.initialize();
  },


  watch: {
    desactivationDialog: function desactivationDialog() {
      if (!this.company) return;
      if (!this.company.hasOwnProperty("active")) return;
      if (this.company.active == undefined || null) return;
      if (this.savingCompany == true) {
        this.desactivationDialog = false;
      }
    }
  },

  methods: {
    searchCnpj: function searchCnpj() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var cnpj;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__service_PersonService__["a" /* default */].searchCnpj(_this.cnpj);

              case 2:
                cnpj = _context.sent;

                if (!cnpj) {
                  _context.next = 12;
                  break;
                }

                _this.company = __WEBPACK_IMPORTED_MODULE_5__utils_LegalPersonConverter__["a" /* default */].getPersonConverterFrom(cnpj);

                if (!(_this.company != {})) {
                  _context.next = 11;
                  break;
                }

                _this.isEditing = false;
                _this.isValidCnpj = true;
                _this.disabledButtonSave = false;
                _context.next = 12;
                break;

              case 11:
                return _context.abrupt("return", 0);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    showAlert: function showAlert(message, color) {
      this.msgAlert = message;
      this.alertColor = color;
      this.alert = true;
    },
    generateDate: function generateDate(_date) {
      var date = new Date(_date);
      return date.toLocaleDateString("pt-BR");
    },
    capitalize: function capitalize(s) {
      return s.toLowerCase().replace(/\b./g, function (a) {
        return a.toUpperCase();
      });
    },
    calculateRecords: function calculateRecords() {
      var amount = 0; //Iniciar em 0
      this.companies.forEach(function (v) {
        return amount++;
      }); //Para cada item nos registros aumentar em 1 (um)
      this.records = amount; //Salvar o número
    },
    closeDialog: function closeDialog() {
      this.dialog = false;
      this.isValidCnpj = false;
      this.cnpj = {};
      this.disabledButtonSave = false;
      this.isEditing = false;
      this.savingCompany = false;
      this.company = this.defaultCompany;
    },
    initialize: function initialize() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.loading) _this2.loading = true; //Se não estiver com o visual de carregamento, o ligar
                _context2.prev = 1;

                if (_this2.companies.length < 1) _this2.alert = false;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3__service_CompanyService__["a" /* default */].getAll();

              case 5:
                _this2.companies = _context2.sent;
                //Receber os registros da API
                _this2.company = _this2.defaultCompany;
                _this2.bankData = new Object();
                _this2.cnpj = new Object();
                _this2.pdfModel = {};
                _this2.editingPdf = false;
                _this2.search = ""; //Limpar dados
                _this2.dialog = false;
                _this2.disabledButtonSave = true;
                _this2.savingCompany = false;
                _this2.calculateRecords(); //Carregar o número de registros
                _this2.isValidCnpj = false;
                _context2.next = 23;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2["catch"](1);

                //Mandar o erro
                _this2.showAlert("Erro ao carregar empresas!", "error");
                console.log(_context2.t0);

              case 23:
                _context2.prev = 23;

                //Tirar o visual de carregamento
                _this2.loading = false;
                return _context2.finish(23);

              case 26:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 19, 23, 26]]);
      }))();
    },
    addCompany: function addCompany() {
      if (this.isValidCnpj == true) {
        this.company = this.defaultCompany;
        this.dialog = true;
        this.disabledButtonSave = false;
        this.isEditing = false;
      } else this.dialog = true;
      this.disabledButtonSave = true;
      this.isEditing = false;
    },
    edit: function edit(itemSelectEdit) {
      if (this.loading) return;
      this.cnpj.cnpj = itemSelectEdit.cnpj;
      this.company = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.defaultCompany, itemSelectEdit); //Carregar o item a ser editado
      this.isEditing = true; //Abrir o dialogo e começar a edição
      this.isValidCnpj = true;
      this.dialog = true;
      this.disabledButtonSave = false;
    },
    activateCompany: function activateCompany() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this3.desactivationDialog = false;
                _this3.savingCompany = true;
                _this3.company.active = true;
                _this3.dialog = false;
                _context3.next = 7;
                return _this3.save();

              case 7:
                _this3.showAlert("Ativada com sucesso!", "success");
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);

                console.log(_context3.t0);

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 10]]);
      }))();
    },
    deactivateCompany: function deactivateCompany() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this4.desactivationDialog = false;
                _this4.company.active = false;
                _this4.dialog = false;
                _context4.next = 6;
                return _this4.save();

              case 6:
                _this4.showAlert("Desativada com sucesso!", "success");
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](0);

                console.log(_context4.t0);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 9]]);
      }))();
    },
    save: function save() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!_this5.$refs.form.validate()) {
                  _context5.next = 26;
                  break;
                }

                if (!_this5.loading) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return");

              case 3:
                _this5.loading = true;
                _context5.prev = 4;

                _this5.dialog = false;
                if (_this5.imageUrl && _this5.company) {
                  _this5.company.companyImage = _this5.imageUrl;
                }

                if (!_this5.company._id) {
                  _context5.next = 13;
                  break;
                }

                _context5.next = 10;
                return __WEBPACK_IMPORTED_MODULE_3__service_CompanyService__["a" /* default */].update(_this5.company);

              case 10:
                _this5.msgAlert = "Alterado com sucesso!";
                _context5.next = 16;
                break;

              case 13:
                _context5.next = 15;
                return __WEBPACK_IMPORTED_MODULE_3__service_CompanyService__["a" /* default */].save(_this5.company);

              case 15:
                _this5.msgAlert = "Salvo com sucesso!";

              case 16:
                _this5.showAlert(_this5.msgAlert, "success");
                _context5.next = 23;
                break;

              case 19:
                _context5.prev = 19;
                _context5.t0 = _context5["catch"](4);

                _this5.showAlert("Erro ao salvar empresa!", "error");
                console.log(_context5.t0);

              case 23:
                _context5.prev = 23;

                _this5.initialize();
                return _context5.finish(23);

              case 26:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[4, 19, 23, 26]]);
      }))();
    },

    /**********\
      * ARQUIVOS *
      \**********/
    //pdfs etc
    savePdf: function savePdf(pdf) {
      this.pdfWindow = false;
      var filter = this.company.companyDocuments.filter(function (document) {
        return document._id === pdf._id;
      });
      var index = this.company.companyDocuments.indexOf(filter[0]);
      if (index != -1) {
        this.company.companyDocuments.splice(index, 1, pdf);
        if (this.pdfModel) {
          this.pdfModel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({});
          this.editingPdf = false;
        }
      }
    },
    editPdf: function editPdf(pdf) {
      this.pdfModel = pdf;
      this.pdfWindow = true;
      this.editingPdf = true;
    },
    removePdf: function removePdf(pdf) {
      var index = this.company.companyDocuments.indexOf(pdf); //indexOf, não findIndex lmao
      if (index != -1 && confirm("Quer mesmo remover esse documento?")) {
        //Confirmar
        this.company.companyDocuments.splice(index, 1); //Remover o index achado pelo indexOf
      }
    },
    pickPdf: function pickPdf() {
      this.$refs.pdf.click(); //Simular um click no elemento que tem como ref "pdf"
    },
    onPdfPicked: function onPdfPicked(e) {
      var _this6 = this;

      if (e && e.target.files) {
        //Caso tenha enviado arquivos
        var pdfs = e.target.files; //Pegar os arquivos enviados
      } else {
          return; //Else retornar e não deixar a função continuar
        }
      if (pdfs[0] != undefined && pdfs.hasOwnProperty(0)) {
        //Se o pdf realmente tem o item 0 , melhor se previnir do que se desculpar
        this.pdfName = pdfs[0].name; //Colocar o pdfName com o nome do arquivo
        if (this.pdfName.lastIndexOf(".") <= 0) {
          //Se o arquivo não tiver um tipo
          return;
        }
        var fileReader = new FileReader(); //Ler arquivo
        if (!pdfs.hasOwnProperty(0)) return;
        fileReader.readAsDataURL(pdfs[0]); //Transformar em base64
        fileReader.addEventListener("load", function () {
          //Callback para quando terminar de dar o upload
          _this6.pdfUrl = fileReader.result; //Pegar o resultado do callback
          if (_this6.company != {} && _this6.editingPdf == false) {
            _this6.company.companyDocuments.push({
              //Inserir os documentos no registro caso não esteja em modo de edição
              name: _this6.pdfName,
              file: _this6.pdfUrl
            });
          } else if (_this6.editingPdf == true) {
            //Caso em modo de edição
            _this6.pdfModel.file = _this6.pdfUrl; //Deixar o pdf a ser editado com o arquivo que levou upload
          }
        });
      } else {
        this.pdfName = ""; //Else deixar tudo vazio
        this.pdfUrl = "";
      }
    },
    openPdf: function openPdf(pdf) {
      if (pdf && pdf != undefined && pdf != null && pdf != "") {
        //Fon
        var pdfWindow = window.open(""); //Cria a janela
        pdfWindow.document.write("<iframe width='100%' height='100%' src='" + encodeURI(pdf) + "'></iframe>"); //Abrir ela com o pdf
        pdfWindow.focus;
      }
    },


    //imagens

    pickImage: function pickImage() {
      this.$refs.image.click();
    },
    onImagePicked: function onImagePicked(e) {
      var _this7 = this;

      var files = e.target.files;
      if (files[0] !== undefined && files.hasOwnProperty(0)) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        var fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", function () {
          _this7.imageUrl = fr.result;
        });
      } else {
        this.imageName = "";
        this.imageUrl = "";
      }
    }
  }
});

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(480);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(155)("734b001a", content, true, {});

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(154)(true);
// imports


// module
exports.push([module.i, ".style[data-v-3022f81c]{border-bottom:1px solid rgba(0,0,0,.1)}.actions-padding[data-v-3022f81c]{padding-right:18px;padding-bottom:19px;padding-left:18px}.pt-switch[data-v-3022f81c]{padding-top:20px}.modal-size[data-v-3022f81c]{width:auto;height:900px}", "", {"version":3,"sources":["/vercel/path0/src/pages/Company.vue"],"names":[],"mappings":"AACA,wBACE,sCAA2C,CAC5C,AACD,kCACE,mBAAoB,AACpB,oBAAqB,AACrB,iBAAmB,CACpB,AACD,4BACE,gBAAkB,CACnB,AACD,6BACE,WAAY,AACZ,YAAc,CACf","file":"Company.vue","sourcesContent":["\n.style[data-v-3022f81c] {\n  border-bottom: 1px solid rgba(0, 0, 0, .1);\n}\n.actions-padding[data-v-3022f81c] {\n  padding-right: 18px;\n  padding-bottom: 19px;\n  padding-left: 18px;\n}\n.pt-switch[data-v-3022f81c] {\n  padding-top: 20px;\n}\n.modal-size[data-v-3022f81c] {\n  width: auto;\n  height: 900px;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"transition":"slide-y-transition"}},[_c('v-alert',{attrs:{"dismissible":"","outline":"","color":_vm.alertColor,"transition":"slide-y-transition"},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_vm._v("\n      "+_vm._s(_vm.msgAlert)+"\n      "),(_vm.companies.length < 1)?_c('v-btn',{attrs:{"small":"","title":"Recarregar","color":_vm.alertColor,"icon":""},on:{"click":function($event){return _vm.initialize();}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("refresh")])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","overlay":true,"max-width":"500px","transition":"dialog-transition"},model:{value:(_vm.desactivationDialog),callback:function ($$v) {_vm.desactivationDialog=$$v},expression:"desactivationDialog"}},[_c('v-card',[_c('v-toolbar',{staticClass:"elevation-1",attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"font-weight-light"},[_vm._v("\n          "+_vm._s(_vm.desactivationDialogTitle)+"\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"color":"error","title":"Cancelar","icon":"","round":"","flat":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.desactivationDialog = false, _vm.company.active = true}}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm.deactivationText))])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"success lighten-1","block":"","outline":"","round":""},on:{"click":_vm.deactivateCompany}},[_vm._v("Aceitar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":_vm.loading == false ? false : true,"overlay":false,"max-width":"500px","transition":"dialog-transition"},model:{value:(_vm.pdfWindow),callback:function ($$v) {_vm.pdfWindow=$$v},expression:"pdfWindow"}},[_c('v-card',[_c('v-toolbar',{staticClass:"elevation-1",attrs:{"color":"white","card":""}},[_c('v-toolbar-title',{staticClass:"black--text font-weight-light"},[_vm._v("\n          "+_vm._s(_vm.pdfWindowTitle)+"\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"color":"error","title":"Cancelar","icon":"","round":"","flat":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.pdfWindow = false, _vm.editingPdf = false}}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"box":"","label":"Nome"},model:{value:(_vm.pdfModel.name),callback:function ($$v) {_vm.$set(_vm.pdfModel, "name", $$v)},expression:"pdfModel.name"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":"","pa-3":""}},[(_vm.pdfModel.file && _vm.pdfName)?_c('v-chip',{staticClass:"white--text font-weight-light",attrs:{"color":"info"}},[_vm._v(_vm._s(_vm.pdfModel.file
            ? _vm.pdfName : _vm.pdfModel.file ? _vm.pdfModel.file :'Sem documentos'))]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-tooltip',{staticStyle:{"width":"100%"},attrs:{"bottom":""}},[_c('v-btn',{staticClass:"white--text font-weight-light headline",attrs:{"slot":"activator","label":" Enviar seus documentos","color":"primary","round":"","block":"","outline":""},on:{"click":_vm.pickPdf},slot:"activator"},[_c('v-icon',[_vm._v("attach_file")])],1),_vm._v(" "),_c('span',{staticClass:"font-weight-light"},[_vm._v("Enviar arquivo (PDF)")])],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"success lighten-1","loading":_vm.loading,"round":"","block":"","disabled":_vm.disabledButtonSave},nativeOn:{"click":function($event){$event.preventDefault();return _vm.savePdf(_vm.pdfModel)}}},[_vm._v("\n          Salvar\n        ")])],1)],1)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"flat":"","mb-2":""}},[_c('v-toolbar-title',{staticClass:"font-weight-light"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.loading,"loading":_vm.loading,"color":_vm.loading ? 'info' : 'info',"icon":"","title":"Inserir um novo registro"},on:{"click":function($event){return _vm.addCompany();}}},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(_vm.loading == false)?_c('v-card',[_c('v-toolbar',{staticClass:"elevation-1",attrs:{"color":"white","card":""}},[_c('v-toolbar-title',{staticClass:"black--text font-weight-light"},[_vm._v("\n            "+_vm._s(_vm.formTitle)+"\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[(_vm.company && _vm.company.active != undefined || null && !_vm.isValidCnpj)?_c('v-switch',{staticClass:"pt-switch",attrs:{"pt-4":"","loading":_vm.loading,"label":_vm.company.active ? "Ativa" : "Inativa"},on:{"click":function($event){$event.preventDefault();_vm.company.active  == true ? _vm.desactivationDialog = true : _vm.activateCompany()}},model:{value:(_vm.company.active),callback:function ($$v) {_vm.$set(_vm.company, "active", $$v)},expression:"company.active"}}):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"error","title":"Cancelar","icon":"","round":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-text-field',{attrs:{"box":"","pa-3":"","label":"CNPJ","mask":"##.###.###/####-##","placeholder":"Informe o CNPJ para iniciar o cadastro","autofocus":"","append-outer-icon":"search","disabled":_vm.isEditing},on:{"click:append-outer":_vm.searchCnpj},model:{value:(_vm.cnpj.cnpj),callback:function ($$v) {_vm.$set(_vm.cnpj, "cnpj", $$v)},expression:"cnpj.cnpj"}}),_vm._v(" "),(_vm.isValidCnpj)?_c('v-layout',{attrs:{"wrap":"","row":""}},[_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-divider'),_vm._v(" "),_c('v-subheader',[_vm._v("Informações Básicas")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"box":"","label":"Razão Social","required":""},model:{value:(_vm.company.socialName),callback:function ($$v) {_vm.$set(_vm.company, "socialName", $$v)},expression:"company.socialName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"box":"","label":"Nome Fantasia","required":""},model:{value:(_vm.company.fantasyName),callback:function ($$v) {_vm.$set(_vm.company, "fantasyName", $$v)},expression:"company.fantasyName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"box":"","label":"Inscrição Estadual","required":""},model:{value:(_vm.company.socialInscription),callback:function ($$v) {_vm.$set(_vm.company, "socialInscription", $$v)},expression:"company.socialInscription"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-divider'),_vm._v(" "),_c('v-subheader',[_vm._v("Endereço")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"box":"","label":"Logradouro"},model:{value:(_vm.company.address.addressType),callback:function ($$v) {_vm.$set(_vm.company.address, "addressType", $$v)},expression:"company.address.addressType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"box":"","label":"Bairro"},model:{value:(_vm.company.address.district),callback:function ($$v) {_vm.$set(_vm.company.address, "district", $$v)},expression:"company.address.district"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"box":"","label":"Complemento"},model:{value:(_vm.company.address.complement),callback:function ($$v) {_vm.$set(_vm.company.address, "complement", $$v)},expression:"company.address.complement"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"box":"","label":"Número"},model:{value:(_vm.company.address.number),callback:function ($$v) {_vm.$set(_vm.company.address, "number", $$v)},expression:"company.address.number"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"box":"","label":"CEP"},model:{value:(_vm.company.address.cep),callback:function ($$v) {_vm.$set(_vm.company.address, "cep", $$v)},expression:"company.address.cep"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"box":"","label":"Município"},model:{value:(_vm.company.address.city),callback:function ($$v) {_vm.$set(_vm.company.address, "city", $$v)},expression:"company.address.city"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"box":"","label":"UF"},model:{value:(_vm.company.address.state),callback:function ($$v) {_vm.$set(_vm.company.address, "state", $$v)},expression:"company.address.state"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"box":"","rules":_vm.emailRules,"label":"E-mail"},model:{value:(_vm.company.contact.email),callback:function ($$v) {_vm.$set(_vm.company.contact, "email", $$v)},expression:"company.contact.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"box":"","label":"Telefone"},model:{value:(_vm.company.contact.phone),callback:function ($$v) {_vm.$set(_vm.company.contact, "phone", $$v)},expression:"company.contact.phone"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"box":"","label":"Fax"},model:{value:(_vm.company.contact.fax),callback:function ($$v) {_vm.$set(_vm.company.contact, "fax", $$v)},expression:"company.contact.fax"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-divider'),_vm._v(" "),_c('v-subheader',[_vm._v("Representante Legal")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"box":"","rules":_vm.inputRules,"label":"Nome"},model:{value:(_vm.company.legalRepresentative.name),callback:function ($$v) {_vm.$set(_vm.company.legalRepresentative, "name", $$v)},expression:"company.legalRepresentative.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"box":"","rules":_vm.inputRules,"label":"RG"},model:{value:(_vm.company.legalRepresentative.rg),callback:function ($$v) {_vm.$set(_vm.company.legalRepresentative, "rg", $$v)},expression:"company.legalRepresentative.rg"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"box":"","rules":_vm.inputRules,"label":"CPF"},model:{value:(_vm.company.legalRepresentative.cpf),callback:function ($$v) {_vm.$set(_vm.company.legalRepresentative, "cpf", $$v)},expression:"company.legalRepresentative.cpf"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-divider'),_vm._v(" "),_c('v-subheader',[_vm._v("Tributação")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-autocomplete',{attrs:{"box":"","label":"Tipo de Tributação","items":_vm.typesOfTributaion,"rules":_vm.taxationRules},model:{value:(_vm.company.taxation.taxationType),callback:function ($$v) {_vm.$set(_vm.company.taxation, "taxationType", $$v)},expression:"company.taxation.taxationType"}})],1),_vm._v(" "),(_vm.company.taxation.taxationType && _vm.company.taxation.taxationType == 'Simples Nacional')?_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"rules":_vm.inputRules,"box":"","type":"number","label":"Taxação Única"},model:{value:(_vm.company.taxation.uniqueTaxation),callback:function ($$v) {_vm.$set(_vm.company.taxation, "uniqueTaxation", $$v)},expression:"company.taxation.uniqueTaxation"}})],1):_vm._e(),_vm._v(" "),(_vm.company.taxation.taxationType && _vm.company.taxation.taxationType != 'Simples Nacional')?_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"rules":_vm.inputRules,"box":"","type":"number","label":"PIS"},model:{value:(_vm.company.taxation.pis),callback:function ($$v) {_vm.$set(_vm.company.taxation, "pis", $$v)},expression:"company.taxation.pis"}})],1):_vm._e(),_vm._v(" "),(_vm.company.taxation.taxationType && _vm.company.taxation.taxationType != 'Simples Nacional')?_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"box":"","type":"number","label":"COFINS"},model:{value:(_vm.company.taxation.cofins),callback:function ($$v) {_vm.$set(_vm.company.taxation, "cofins", $$v)},expression:"company.taxation.cofins"}})],1):_vm._e(),_vm._v(" "),(_vm.company.taxation.taxationType && _vm.company.taxation.taxationType != 'Simples Nacional')?_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"box":"","rules":_vm.inputRules,"type":"number","label":"ISS"},model:{value:(_vm.company.taxation.iss),callback:function ($$v) {_vm.$set(_vm.company.taxation, "iss", $$v)},expression:"company.taxation.iss"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-divider'),_vm._v(" "),_c('v-subheader',[_vm._v("Dados Bancários")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"box":"","rules":_vm.inputRules,"label":"Número do Banco"},model:{value:(_vm.company.bankData.bankNumber),callback:function ($$v) {_vm.$set(_vm.company.bankData, "bankNumber", $$v)},expression:"company.bankData.bankNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"box":"","rules":_vm.inputRules,"label":"Nome do Banco"},model:{value:(_vm.company.bankData.nameBank),callback:function ($$v) {_vm.$set(_vm.company.bankData, "nameBank", $$v)},expression:"company.bankData.nameBank"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"box":"","rules":_vm.inputRules,"label":"Agência"},model:{value:(_vm.company.bankData.agency),callback:function ($$v) {_vm.$set(_vm.company.bankData, "agency", $$v)},expression:"company.bankData.agency"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"box":"","rules":_vm.inputRules,"label":"Conta"},model:{value:(_vm.company.bankData.account),callback:function ($$v) {_vm.$set(_vm.company.bankData, "account", $$v)},expression:"company.bankData.account"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center text-sm-center text-md-center text-lg-center",attrs:{"xs12":""}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('h1',{staticClass:"font-weight-light body-1 black--text headline"},[_vm._v(" Logo ")])])],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-avatar',{attrs:{"slot":"activator","size":"120","color":"primary"},slot:"activator"},[(_vm.company.companyImage)?_c('v-img',{attrs:{"height":"120","src":_vm.company.companyImage},on:{"click":_vm.pickImage}}):(_vm.company.socialName)?_c('span',{staticClass:"white--text display-1"},[_vm._v(_vm._s(_vm.company.socialName[0]))]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.loading,"dark":"","absolute":"","large":"","centered":"","flat":"","icon":"","block":"","round":""},on:{"click":_vm.pickImage}},[_c('v-icon',[_vm._v("attach_file")])],1)],1),_vm._v(" "),_c('span',{staticClass:"font-weight-light"},[_vm._v("Enviar imagem (Logo)")])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"font-weight-light black--text",attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{directives:[{name:"show",rawName:"v-show",value:(_vm.imageName),expression:"imageName"}]},[_vm._v(_vm._s(_vm.imageName ? _vm.imageName : 'Selecione uma imagem'))])],1),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('input',{ref:"image",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onImagePicked}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center text-sm-center text-md-center text-lg-center",attrs:{"xs12":""}},[_c('v-layout',{staticClass:"black--text font-weight-light headline",attrs:{"row":"","justify-center":""}},[_vm._v("\n                    Documentos\n                  ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-footer',{staticClass:"pa-3 elevation-1",staticStyle:{"border-radius":"5px"},attrs:{"height":"auto","width":"100%","color":"info"}},[_c('span',{staticClass:"white--text"},[_c('strong',[_vm._v("AVISO:")]),_vm._v("\n                      Todos arquivos enviados devem conter o formato '.pdf', caso contrário os arquivos não serão\n                      aceitos!\n                    ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{staticClass:"px-3 pt-3",attrs:{"row":"","justify-center":""}},[_c('v-tooltip',{staticStyle:{"width":"100%"},attrs:{"bottom":""}},[_c('v-btn',{staticClass:"white--text font-weight-light headline",attrs:{"slot":"activator","label":" Enviar seus documentos","color":"primary","round":"","block":"","large":"","outline":""},on:{"click":_vm.pickPdf},slot:"activator"},[_vm._v("\n                        E"),_c('a',{staticClass:"text-lowercase"},[_vm._v("nviar")]),_vm._v(" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("attach_file")])],1),_vm._v(" "),_c('span',{staticClass:"font-weight-light"},[_vm._v("Enviar arquivos (PDF)")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.pdfName)?_c('v-chip',{staticClass:"white--text font-weight-light",attrs:{"color":"info"}},[_vm._v(_vm._s(_vm.pdfName ? _vm.pdfName :
                      'Sem documentos selecionados'))]):_vm._e()],1),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('input',{ref:"pdf",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"application/pdf"},on:{"change":_vm.onPdfPicked}}),_vm._v(" "),(_vm.company.companyDocuments)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[(_vm.company.companyDocuments.length > 0)?_c('v-data-iterator',{attrs:{"items":_vm.company.companyDocuments,"content-tag":"v-layout","row":"","wrap":"","hide-actions":"","no-data-text":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('v-flex',{staticClass:"px-0",attrs:{"xs12":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"primary","card":""}},[_c('v-toolbar-title',{staticClass:"white--text font-weight-light"},[_vm._v(_vm._s(props.item.name)+"\n                              ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[(props.item.name.slice(-3) == 'pdf')?_c('v-btn',{attrs:{"color":"red accent-2","disabled":"","small":"","round":"","icon":""}},[_c('v-avatar',{staticClass:"font-weight-light white--text",attrs:{"size":"30","color":"red accent-2"}},[_vm._v("\n                                    "+_vm._s(props.item.name.slice(-3))+"\n                                  ")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"white","icon":"","flat":"","round":""},on:{"click":function($event){return _vm.openPdf(props.item.file)}}},[_c('v-icon',[_vm._v("call_made")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"teal lighten-2","icon":"","flat":"","round":""},on:{"click":function($event){return _vm.editPdf(props.item)}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"error","icon":"","flat":"","round":""},on:{"click":function($event){return _vm.removePdf(props.item)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)],1)],1)],1)}}],null,false,3363919767)}):_vm._e()],1)],1):_vm._e()],1)],1):_vm._e()],1)],1)],1),_vm._v(" "),(_vm.company.cnpj)?_c('v-card-actions',{staticClass:"actions-padding"},[_c('v-btn',{staticClass:"mx-4 mb-4",attrs:{"color":"success lighten-1","loading":_vm.loading,"large":"","round":"","block":"","disabled":_vm.disabledButtonSave},on:{"click":function($event){return _vm.save();}}},[_vm._v("\n            Salvar\n          ")])],1):_vm._e()],1):_vm._e()],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 font-weight-light",attrs:{"headers":_vm.headers,"loading":_vm.loading,"search":_vm.search,"items":_vm.companies,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.capitalize(props.item.socialName)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.capitalize(props.item.fantasyName)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.cnpj))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.contact.email))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.contact.phone))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"white--text font-weight-light",attrs:{"small":"","color":props.item.active == false ? 'error' : 'success lighten-1',"disabled":props.item.active == false}},[_vm._v("\n          "+_vm._s(props.item.active == false ? 'Inativa' : 'Ativa'))])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{attrs:{"color":"info","round":"","flat":"","icon":"","title":"Editar registro","disabled":_vm.loading},on:{"click":function($event){return _vm.edit(props.item)}}},[_c('v-icon',[_vm._v("edit")])],1)],1)],1)]}}])},[_vm._v(" "),_c('div',{attrs:{"slot":"no-results","value":true},slot:"no-results"},[_c('h3',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.emptySearchText)+" \""+_vm._s(_vm.search)+"\".")])]),_vm._v(" "),(_vm.records > 0)?_c('template',{slot:"footer"},[_c('td',{attrs:{"colspan":"100%"}},[_c('strong',[_vm._v(" "+_vm._s(_vm.footerText)+" "+_vm._s(_vm.records)+" ")])])]):_c('template',{slot:"no-data"},[_c('strong',[_vm._v(" "+_vm._s(_vm.footerDynamicText)+" ")])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.576e3ff0a6fd25cc3625.js